import {
    Box,
    Fade,
    LinearProgress,
    useTheme
} from '@mui/material';

import Messages from '@/components/layouts/Messages';
import { LoadingContext } from '@/contexts/layouts/LoadingContext';
import { FunctionComponent, ReactNode, useContext } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Navigation from './navigation/Navigation';

export interface ILink
{
    url: string;
    icon: any;
    newTab: boolean;
    route: boolean;
    title: string;
}

interface ILayoutProps {
    links?: ILink[];
    children?: ReactNode;
}

const DefaultLayout: FunctionComponent<ILayoutProps> = ({ children }) => {
    const theme = useTheme();
    const { loading, validating } = useContext(LoadingContext);


    return (
        <Box 
            sx={{
                display: 'flex',
                width: '100%'
            }}
        >
            <ScrollRestoration />
            <Navigation />
            <Box 
                sx={{
                    flexGrow: 1,
                    padding: theme.spacing(3),
                    width: '80%'
                }}
            >
                <Box 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: theme.spacing(0, 1),
                        // necessary for content to be below app bar
                        ...(theme.mixins.toolbar as any),
                        minHeight: `${theme.spacing(8)} !important`
                    }}
                />
                { 
                    (loading || validating) && (
                        <Box
                            sx={{
                                position: 'fixed',
                                left: 0,
                                right: 0,
                                top: theme.spacing(8)
                            }}
                        >
                            <LinearProgress color="secondary" />
                        </Box>
                    ) 
                }
                <Messages />
                {/* <Fade appear in={routeLoaded}> */}
                <Fade appear in={!loading}>
                    <div>
                        <Outlet />
                        {children}
                    </div>
                </Fade>
            </Box>
            <div id="post-content">

            </div>
        </Box>
    );
};

export default DefaultLayout;